import { contractManager } from '../model';

export const saveEstimatedRetention = (amount?: number | null) => {
  contractManager.estimatedRetention = amount ?? 0;
};
